import {
    DeliveryProvider,
    Driver,
    KitchenMetrics,
    OperatingContext,
    OracleState,
    Order,
    RoutingRecommendationMode,
    SmartSplitSuggestion,
    SystemConfig
} from '../../../types';
import { calculateSmartSplitAsync } from './smartSplit';
import { calculateSimplifiedSplitAsync } from './simplifiedSplit';

/**
 * Roteador de estrategias de recomendacao.
 *
 * Diferencas entre os modos:
 * - advanced (padrao e fallback): motor completo existente com arbitragem multi-sinal e estrategias avancadas.
 * - simplified: regras deterministicas e explicaveis para operacao previsivel.
 */
export const resolveRoutingRecommendationMode = (config: SystemConfig): RoutingRecommendationMode => {
    return config.routingRecommendationMode === 'simplified' ? 'simplified' : 'advanced';
};

export const calculateRoutingRecommendationAsync = async (
    orders: Order[],
    config: SystemConfig,
    drivers: Driver[],
    providers: DeliveryProvider[],
    context: OperatingContext,
    storeId?: string,
    oracle?: OracleState,
    kitchen?: KitchenMetrics
): Promise<SmartSplitSuggestion> => {
    const mode = resolveRoutingRecommendationMode(config);

    if (mode === 'simplified') {
        return calculateSimplifiedSplitAsync(orders, config, drivers, providers, context);
    }

    return calculateSmartSplitAsync(orders, config, drivers, providers, context, storeId, oracle, kitchen);
};
